module.exports = __webpack_public_path__ + "static/hedgehog-trivia-logo-white-160f04de177af0d2adbdc5b6aa189315.svg";